import styled from 'styled-components';
import { MARIGOLD_LIGHT } from 'HubStyleTokens/colors';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { ILLUSTRATIONS, IMAGE_BACKGROUND_OVERRIDES } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
const ImageWrapper = styled.div.withConfig({
  displayName: "PopularFeaturesPanelImage__ImageWrapper",
  componentId: "sc-17qm9n5-0"
})(["text-align:center;width:300px;background-color:", ";"], props => props.shortName in IMAGE_BACKGROUND_OVERRIDES ? IMAGE_BACKGROUND_OVERRIDES[props.shortName] : MARIGOLD_LIGHT);
const PopularFeaturesPanelImage = ({
  featureRecord
}) => featureRecord ? /*#__PURE__*/_jsx(ImageWrapper, {
  shortName: featureRecord.shortName,
  children: /*#__PURE__*/_jsx(UIIllustration, {
    name: ILLUSTRATIONS[featureRecord.shortName],
    height: 132,
    className: "m-y-2"
  })
}) : null;
export default PopularFeaturesPanelImage;